// Phase 1A Phase 9C.1 — Elevation / depth style helpers.
//
// Reusable CSSProperties exports that wrap the new shadow + glow tokens
// from tokens.css (--sz-shadow-* family). Every consumer should spread
// these into a component's style object rather than rewriting the
// box-shadow string.
//
// Trust contract:
//   - Token-only. No raw hex/rgb. No motion implying live data.
//   - No imports from components. No business copy. No side effects.
//   - Adoption begins in 9C.3+. No UI surface consumes these in 9C.1.

import type { CSSProperties } from "react";

// ─── Card elevation tiers ───────────────────────────────────────

export const cardSubtle: CSSProperties = {
  boxShadow: "var(--sz-shadow-subtle)",
};

export const cardLow: CSSProperties = {
  boxShadow: "var(--sz-shadow-low)",
};

export const cardMedium: CSSProperties = {
  boxShadow: "var(--sz-shadow-medium)",
};

export const cardHigh: CSSProperties = {
  boxShadow: "var(--sz-shadow-high)",
};

export const cardFloating: CSSProperties = {
  boxShadow: "var(--sz-shadow-floating)",
};

// ─── Glow rings (state-tied) ────────────────────────────────────

export const amberGlow: CSSProperties = {
  boxShadow: "var(--sz-shadow-amber-glow)",
};

export const successGlow: CSSProperties = {
  boxShadow: "var(--sz-shadow-success-glow)",
};

export const dangerGlow: CSSProperties = {
  boxShadow: "var(--sz-shadow-danger-glow)",
};

// ─── Selected / active rings ────────────────────────────────────
//
// Combine elevation with an amber edge ring. Used for "currently
// selected" rows or active board cards. Keep ring thickness small —
// 2px ring + 24px glow is the disciplined limit.

export const selectedRing: CSSProperties = {
  boxShadow: "0 0 0 2px var(--sz-amber), var(--sz-shadow-amber-glow)",
};

export const successRing: CSSProperties = {
  boxShadow: "0 0 0 2px var(--sz-success), var(--sz-shadow-success-glow)",
};

export const dangerRing: CSSProperties = {
  boxShadow: "0 0 0 2px var(--sz-danger), var(--sz-shadow-danger-glow)",
};

// ─── Composed elevation + ring (most common selected-card pattern) ─

export const cardLowSelected: CSSProperties = {
  boxShadow: "0 0 0 2px var(--sz-amber), var(--sz-shadow-low), var(--sz-shadow-amber-glow)",
};

export const cardMediumSelected: CSSProperties = {
  boxShadow: "0 0 0 2px var(--sz-amber), var(--sz-shadow-medium), var(--sz-shadow-amber-glow)",
};
